import { getAuth0Token } from './auth.service';

const apiUrl = process.env.REACT_APP_API_GATEWAY_URL + "conversations";

export async function getParticipants(conversationId) {
  try {
    const token = await getAuth0Token();
    const url = `${apiUrl}?conversationId=${conversationId}`;

    console.log("[getParticipants] Fetching participants from:", url);
    console.log("[getParticipants] Headers:", {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    console.log("[getParticipants] Response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[getParticipants] Error response:", errorText);
      throw new Error(`Error fetching participants: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("[getParticipants] Data received:", data);
    return data;
  } catch (error) {
    console.error("[getParticipants] Error:", error);
    throw error;
  }
}

export async function addParticipant(participantData) {
  try {
    const token = await getAuth0Token();
    console.log("[addParticipant] Adding participant:", participantData);

    const response = await fetch(apiUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(participantData)
    });

    console.log("[addParticipant] Response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[addParticipant] Error response:", errorText);
      throw new Error(`Error adding participant: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("[addParticipant] Participant added:", data);
    return data;
  } catch (error) {
    console.error("[addParticipant] Error:", error);
    throw error;
  }
}

export async function removeParticipant(participantId) {
  try {
    const token = await getAuth0Token();
    const payload = { id: participantId };

    console.log("[removeParticipant] Removing participant with ID:", participantId);

    const response = await fetch(apiUrl, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });

    console.log("[removeParticipant] Response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[removeParticipant] Error response:", errorText);
      throw new Error(`Error removing participant: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("[removeParticipant] Participant removed:", data);
    return data;
  } catch (error) {
    console.error("[removeParticipant] Error:", error);
    throw error;
  }
}

